import * as yup from 'yup';

import { phoneRegExp, emailRegExp, usernameRegExp, houseNoRegExp, passwordRegExp } from '../helper/Regex';

const email = yup.string().required("Bitte eine E-Mail-Adresse eingeben.").matches(emailRegExp, 'Die E-Mail-Adresse ist ungültig.');
const emailRepeat = yup.string().required("Bitte die E-Mail-Adresse wiederholen.").oneOf([yup.ref('Email'), null], 'Die E-Mail-Adressen müssen übereinstimmen.');
const password = yup.string().required("Bitte ein Passwort eingeben.").min(6, "Bitte mindestens 6 Stellen eingeben.").matches(passwordRegExp, { message: "Ihr Passwort ist nicht stark genug. Es muss mindestens einen Großbuchstaben, einen Kleinbuchsthaben und eine Zahl enthalten." });
const passwordRepeat = yup.string().required("Bitte das Password wiederholen.").oneOf([yup.ref('Password'), null], 'Die Passwörter müssen übereinstimmen.');
const username = yup.string().required("Bitte einen Benutzernamen eingeben.").matches(usernameRegExp, 'Der Username darf kein @ enthalten.');

const salutation = yup.string().required("Bitte eine Anrede angeben.");
const firstName = yup.string().required("Bitte einen Vornamen eingeben.");
const lastName = yup.string().required("Bitte einen Nachnamen eingeben.");
const organisationName = yup.string().required("Bitte eine Bezeichnung eingeben.");

const phoneNoReq = yup.string().required("Bitte eine Telefonnummer eingeben.").matches(phoneRegExp, 'Die Telefonnummer ist ungültig.');
const phoneNo = yup.string().matches(phoneRegExp, 'Die Telefonnummer ist ungültig.');
const street = yup.string().required("Bitte eine Straße eingeben.");
const houseNo = yup.string().required("Bitte eine Hausnummer eingeben.").matches(houseNoRegExp, 'Die Hausnummer muss mit einer Zahl beginnen.');
const city = yup.string().required("Bitte eine Stadt eingeben.");
const postCode = yup.string().required("Bitte eine Postleitzahl eingeben.").length(5, "Bitte 5-stellige Postleitzahl eingeben.").matches(/^[0-9]{5}/, "Bitte nur Zahlen eingeben.");

const court = yup.string().required("Bitte ein Amtsgericht eingeben.");
const compRegNo = yup.string().required("Bitte eine Handelsregisternummer eingeben.");
const chamberMembership = yup.string().required("Bitte eine Kammerzugehörigkeit eingeben.");

const dataProtection = yup.bool().required('Bitte willigen Sie in die Datenverarbeitung ein.').oneOf([true], 'Bitte willigen Sie in die Datenverarbeitung ein.');
const conditionUse = yup.bool().required('Sie müssen den Nutzungsbedingungen zustimmen.').oneOf([true], 'Sie müssen den Nutzungsbedingungen zustimmen.');

const code = yup.string().required("Bitte einen Code angeben.");

const subject = yup.string().required("Bitte einen Betreff angeben.");

const date = yup.date().required("Bitte ein Datum eingeben.").min(new Date().toISOString().substring(0, 10), "Bitte kein vergangenes Datum angeben.");
const timeStart = yup.string().required("Bitte eine Anfanszeit eingeben.");
const timeEnd = yup.string().required("Bitte eine Endzeit eingeben."); // .test("checkEndTime", "Die Endzeit muss mindestens 30 Minuten nach der Startzeit liegen.", (value) => { return validateTimes(formRef.current.values.timeStart, value, 30); })
const grade = yup.number().integer("Bitte nur ganze Zahlen angeben").min(5, "Bitte einen Wert zwischen 5 und 13 angeben").max(13, "Bitte einen Wert zwischen 5 und 13 angeben");
const nameClass = yup.string().required("Bitte einen Klassennamen eingeben.");

const newsletterOptIn = yup.bool();
const additionToAddress = yup.string();

const intervalTime = yup.number().integer("Bitte nur ganze Zahlen angeben").min(1, "Bitte einen Wert von min. 1 angeben");

const requiredPhoneNo = yup.string().required("Bitte eine Telefonnummer eingeben.").matches(phoneRegExp, 'Die Telefonnummer ist ungültig.');
const requiresRadioOrganisationType = yup.string().oneOf(["1", "2", "3"], "Bitte wählen Sie eine Option aus.");

const contactText = yup.string().max(65535, "Der Text darf niht länger als 65535 Zeichen lang sein.");

export {
    email,
    emailRepeat,
    password,
    passwordRepeat,
    username,
    salutation,
    firstName,
    lastName,
    organisationName,
    phoneNoReq,
    phoneNo,
    street,
    houseNo,
    city,
    postCode,
    court,
    compRegNo,
    chamberMembership,
    dataProtection,
    code,
    subject,
    date,
    timeStart,
    timeEnd,
    grade,
    nameClass,
    newsletterOptIn,
    additionToAddress,
    conditionUse,
    intervalTime,
    requiredPhoneNo,
    requiresRadioOrganisationType,
    contactText,
}